import React from 'react';
import SearchableSelect from '../../../../../../generic/ui/SearchableSelect/SearchableSelect';
import FilterIcon from '../../../../../../generic/icons/IconLib/FilterIcon';

export type TLikutView = 'def' | 'all' | 'inPallet';

interface IViewOption {
    value: TLikutView;
    label: string;
}

const OPTIONS: IViewOption[] = [
    { value: 'def', label: 'לקוט' },
    { value: 'all', label: 'הכל' },
    { value: 'inPallet', label: 'במשטח' },
];

interface Props {
    value: TLikutView;
    onSelect: (value: TLikutView) => void;
    disabled?: boolean;
    className?: string;
}

const LikutViewSelector: React.FC<Props> = ({ value, onSelect, disabled, className }) => (
    <SearchableSelect<IViewOption>
        items={OPTIONS}
        value={OPTIONS.find((o) => o.value === value) ?? OPTIONS[0]}
        onSelect={(option) => {
            if (option) onSelect(option.value);
        }}
        getKey={(o) => o.value}
        getLabel={(o) => o.label}
        placeholder='תצוגה'
        disabled={disabled}
        leadingIcon={<FilterIcon />}
        className={className}
        emptyLabel='—'
    />
);

export default LikutViewSelector;
